import { render, staticRenderFns } from "./MonthlySocsoPublic.vue?vue&type=template&id=21dd0ec3"
import script from "./MonthlySocsoPublic.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports